export default "/images/git-branch.svg?120adf52f8c4855276742c1d33c5b94f";